import moment from "moment";

export default function (date) {
    return moment(date).format('dddd D MMMM YYYY HH:mm');
}
